module.exports = __webpack_public_path__ + "static/img/title_5_blue@2x.59f4c3aa.png";